import { Header } from "../Header/";
import { Footer } from "../Footer/";

import "./layout.sass";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  toggleLoginModal,
  toggleSignUpModal,
} from "@actions/authModalsActions";
import { useLocation } from "react-router-dom";
import AuthModal from "@components/auth/modals/AuthModal";
import { HeaderLanding } from "@components/layout/Header/HeaderLanding";
import { FooterLanding } from "../Footer/FooterLanding";

export const Layout = ({ children }) => {
  const { isSignUpOpen, isLogInOpen } = useSelector(
    (state) => state.authModals
  );
  const { isAuth, isDemoUser } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const [modalView, setModalView] = useState(null);
  const normalizedPath = pathname.toLowerCase();
  const isAuthPageRoute =
    normalizedPath.startsWith("/auth/") || normalizedPath.includes("/auth/");

  const handleSignUpToggle = (isOpen) => {
    dispatch(toggleSignUpModal(isOpen));
  };

  const handleLoginToggle = (isOpen) => {
    dispatch(toggleLoginModal(isOpen));
  };

  useEffect(() => {
    if (isSignUpOpen) {
      setModalView("signup");
    } else if (isLogInOpen) {
      setModalView("login");
    } else {
      setModalView(null);
    }
  }, [isSignUpOpen, isLogInOpen]);

  useEffect(() => {
    handleSignUpToggle(false);
    handleLoginToggle(false);
    setModalView(null);
  }, [pathname]);

  const handleCloseModal = () => {
    handleSignUpToggle(false);
    handleLoginToggle(false);
    setModalView(null);
  };

  const handleSetView = (view) => {
    setModalView(view);
  };

  return (
    <div
      className={
        isAuth ? "base-wrap" : "base-wrap base-wrap--landing"
      }
    >
      {!isAuthPageRoute && (
        <div className="base-wrap__header">
          {isAuth ? <Header /> : <HeaderLanding />}
        </div>
      )}

      <div className="base-wrap__content">{children}</div>

      <div className="base-wrap__footer">
        {isAuth ? <Footer /> : <FooterLanding />}
      </div>

      {/* {(isSignUpOpen || isLogInOpen) && (!isAuth || isDemoUser) && ( */}
      <AuthModal
        isOpen={
          (isSignUpOpen || isLogInOpen) &&
          (!isAuth || isDemoUser) &&
          modalView !== null
        }
        onClose={handleCloseModal}
        view={modalView}
        setView={handleSetView}
      />
      {/* )} */}
    </div>
  );
};
